import { api } from '@api'

const getConfData = async () => {
  const response = await api.get('/configurations')
  return response.data
}

export const getConfDataApi = {
  getConfData,
}
